var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatars = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.073 46.6c.782.486 1.564.81 2.659.81 1.564 0 2.971-.81 3.91-2.105l.47-.81-1.878 17.486c-.156 2.59 1.72 4.857 4.223 5.019h.313c1.877 0 3.597-1.133 4.223-2.914.782 1.78 2.502 2.914 4.379 2.914h.313c2.502-.324 4.379-2.429 4.222-5.181l-1.876-17.486.469.81c.782 1.295 2.346 2.105 3.91 2.105.938 0 1.72-.324 2.502-.81 1.095-.648 1.877-1.78 2.034-3.076.156-1.133 0-2.429-.782-3.4l-7.038-10.686c-.939-1.295-2.346-1.943-3.91-1.943h-.157c.157-.162.313-.323.47-.323 1.094-1.296 1.876-2.915 1.876-4.534 0-1.78-.626-3.4-1.877-4.695C45.434 16.648 43.713 16 41.993 16c-1.72 0-3.441.648-4.536 1.781-1.251 1.295-1.877 2.914-1.877 4.533 0 1.62.782 3.238 2.034 4.534.156.162.312.323.469.323h-.313c-1.564 0-2.972.81-3.91 2.105l-7.038 10.848c-.626.971-.938 2.267-.782 3.4.313 1.295.938 2.428 2.033 3.076Zm10.948-27.038c.782-.81 1.877-1.295 3.128-1.295 1.251 0 2.346.485 3.128 1.133a4.502 4.502 0 0 1 1.251 3.076c0 1.134-.469 2.267-1.094 2.915-1.877 1.78-4.692 1.619-6.256 0a4.045 4.045 0 0 1-1.408-3.077c0-.81.47-1.943 1.251-2.752ZM28.542 41.419l7.038-10.524c.47-.81 1.252-1.133 2.19-1.133h8.602c.938 0 1.72.486 2.19 1.133L55.6 41.42c.312.486.469 1.133.312 1.781-.156.648-.469 1.295-1.094 1.619-1.095.81-2.816.486-3.598-.648l-2.815-4.21c-.313-.323-.782-.485-1.251-.323-.47.162-.782.648-.626 1.133l2.346 21.696c.157 1.457-.938 2.59-2.346 2.752h-.156c-1.408 0-2.502-.971-2.659-2.267l-.782-12.304c0-.486-.47-.972-1.095-.972s-.938.486-1.094.972l-.313 12.142c-.157 1.296-1.252 2.267-2.66 2.267h-.312c-1.407-.162-2.502-1.457-2.346-2.752l2.346-21.696c0-.485-.156-.97-.626-1.133-.469-.162-.938 0-1.25.324l-2.816 4.21a2.708 2.708 0 0 1-2.19 1.133 3.035 3.035 0 0 1-1.407-.324c-.626-.324-.938-.971-1.095-1.619 0-.648.157-1.295.47-1.781Z",
    fill: "currentColor"
  }))));
};
export { SvgAvatars as ReactComponent };